(() => {
  let busy = false;
  class SetQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.label = this.button.textContent;
      this.button.hidden = false;
      this.button.addEventListener('click', () => this.add());
    }

    async add() {
      if (busy) return;
      busy = true;
      document.querySelectorAll('bc-set-quick-add button').forEach(button => { button.disabled = true; });
      this.button.textContent = 'Adding Your Set…';
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      let addingToCart = false;
      try {
        const key = crypto.randomUUID().replaceAll('-', '') + crypto.randomUUID().replaceAll('-', '');
        const base = this.getAttribute('api-base');
        const catalogResponse = await fetch(`${base}/ready-made-catalog`, { headers: { 'X-Design-Key': key } });
        if (!catalogResponse.ok) throw Error('Set options could not load. Please try again or view the designs below.');
        const catalog = await catalogResponse.json();
        const product = catalog.products.find(product => product.handle === this.getAttribute('product-key'));
        if (!product || product.designs.length !== 20 || new Set(product.designs.map(design => design.id)).size !== 20) {
          throw Error('Please open View The Set to order this set.');
        }
        const orderResponse = await fetch(`${base}/ready-made-order`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Design-Key': key },
          body: JSON.stringify({ designs: product.designs.map(design => ({ id: design.id, quantity: 1 })) })
        });
        const order = await orderResponse.json();
        if (!orderResponse.ok) throw Error(order.error || 'This set could not be prepared. Please view the options below.');
        if (order.total !== 20 || order.totalPrice !== Number(this.getAttribute('expected-price')) || !order.cartItem) {
          throw Error('Set options have changed. Please refresh or view the options below.');
        }
        addingToCart = true;
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [order.cartItem] })
        });
        const cart = await cartResponse.json();
        addingToCart = false;
        if (!cartResponse.ok) throw Error(cart.description || 'Your set could not be added. Please try again.');
        window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
      } catch (error) {
        this.status.textContent = addingToCart
          ? 'We could not confirm the cart update. Check your cart before trying again.'
          : error.message;
      } finally {
        busy = false;
        document.querySelectorAll('bc-set-quick-add button').forEach(button => { button.disabled = false; });
        this.button.textContent = this.label;
        this.removeAttribute('aria-busy');
      }
    }
  }
  if (!customElements.get('bc-set-quick-add')) customElements.define('bc-set-quick-add', SetQuickAdd);
})();
